import { all } from 'redux-saga/effects'

//admin
import adminAuthSaga from '../admin/redux/auth/saga'
import adminSettingSaga from '../admin/redux/settings/saga'
import providerManagementSaga from '../admin/redux/providerManagement/saga'
import adminCMSSaga from '../admin/redux/cms/saga'
import adminManagePharmacy from '../admin/redux/managePharmacy/saga'

//main
import userAuthSaga from '../main/redux/auth/saga'
import userProviderManagementSaga from '../main/redux/providerManagement/saga'

//ambulance
import mainAuthSaga from '../main/redux/auth/saga'

//doctor
import doctorAuthSaga from '../doctor/redux/auth/saga'

//hospital
import hospitalAuthSaga from '../hospital/redux/auth/saga'

//lab
import labAuthSaga from '../lab/redux/auth/saga'

//patient
import patientAuthSaga from '../patient/redux/auth/saga'

// Pharmacy
import pharmacyAuthSaga from '../pharmacy/redux/auth/saga'

// admin Pharmacy
import pharmacyAdminManagePharmacy from '../pharmacy/redux/managePharmacy/saga'

// admin Laboratory
import laboratoryAuthSaga from '../laboratory/redux/auth/saga'
import ManageLab from '../laboratory/redux/manageLaboratory/saga'
// admin Laboratory
import scanCenterAuthSaga from '../scanCenter/redux/auth/saga'
import ManageScanCenter from '../scanCenter/redux/manageScanCenter/saga'

export default function* rootSaga() {
  yield all([
    adminAuthSaga(),
    adminSettingSaga(),
    providerManagementSaga(),
    adminCMSSaga(),
    mainAuthSaga(),
    userProviderManagementSaga(),
    doctorAuthSaga(),
    hospitalAuthSaga(),
    labAuthSaga(),
    patientAuthSaga(),
    adminManagePharmacy(),
    pharmacyAuthSaga(),
    userAuthSaga(),
    pharmacyAdminManagePharmacy(),
    laboratoryAuthSaga(),
    ManageLab(),
    scanCenterAuthSaga(),
    ManageScanCenter(),
  ])
}
